export const ASSESSMENTS_LOGIN_FAILURE_REASONS = {
  INVALID_CREDENTIALS: 'invalid_credentials',
  SERVER_ERROR: 'server_error',
  NETWORK_ERROR: 'network_error',
};
